import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from 'antd/lib/typography';

interface TotalQuantityProps {
	count?: number;
	withTotalQuantity?: boolean;
}

export const TotalQuantity: React.FC<TotalQuantityProps> = ({ count, withTotalQuantity }: TotalQuantityProps) => {
	const { t } = useTranslation('translation');

	if (!withTotalQuantity) return null;

	return (
		<Typography.Text type="secondary" style={{ textAlign: 'end' }}>
			{count} {t('filters.quantity')}
		</Typography.Text>
	);
};
